<template>
<div ref="container" class="row-zone" @drop="Drop" @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()">
    <img v-for="i in 20" :key="i" class="field-card" 
    :style="{height: `${height}px`, width: `${width}px`, 'margin-left': `-${i > 1 ? negativeSpace : 0}px`}" 
    :src="require('@/assets/previews/ESP-001.png')" draggable="true">
</div>
</template>

<script>
export default {
    mounted() {
        
        this.Resize();
        window.addEventListener('resize', this.Resize);
        
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.Resize);
    },
    data() {
        return {
            height: 0,
            width: 0,
            negativeSpace: 0
        }
    },
    methods: {
        Drop(e) {
            console.log(e);
        },
        Resize() {
            let ratio = 0.697;
            let rect = this.$refs.container.getBoundingClientRect();
            this.height = rect.height;
            this.width = rect.height * ratio;
            
            let count = this.$refs.container.childNodes.length;
            let totalWidth = count*this.width;

            this.negativeSpace = 0;
            if(totalWidth > rect.width && count > 1)
            {
                let extraSpace = (totalWidth - rect.width) + this.width;
                this.negativeSpace = extraSpace/(count-1);
            }

        }
    },
}
</script>

<style>
.row-zone {
    height: 100%;
    width: 100%;
    background: red;
}
</style>